import React from 'react';
import './PrivacyPolicy.css';

const PrivacyPolicy = () => {

    return (
        <div className="container">

            <h1>Privacy Policy for AI Chef App</h1>
            <h2>Introduction</h2>
            <p>
                AI Chef is dedicated to protecting your privacy and handling any personal information we obtain from you
                with care and respect. This Privacy Policy is designed to answer your questions regarding our privacy
                policies and principles.
            </p>
            <h2>Anonymous User Profiles</h2>
            <p>
                AI Chef creates anonymous user profiles to associate recipes with users. These profiles are used to
                personalize your experience and to store your generated recipes, preferences, and settings.
            </p>
            <h2>Conversion to Non-anonymous Profile</h2>
            <p>
                You have the option to convert your anonymous profile into a non-anonymous profile at any time. This
                allows you to personalize your experience further and access additional features. The conversion process
                will require you to provide certain identifiable information.
            </p>
            <h2>Data Storage</h2>
            <p>
                All data related to the recipes you create, including AI-generated recipe images and descriptions, are
                stored in Firebase Firestore. We ensure that no personal data is included in the recipe data stored in
                our database.
            </p>
            <h2>No Sharing of Personal Data</h2>
            <p>
                AI Chef does not share any personal data with third parties. We are committed to ensuring that your
                information is secure and is used solely for the purpose of enhancing your experience with our app.
            </p>
            <h2>Data Collection</h2>
            <p>
                We collect data necessary for the operation of the app, including:
            </p>
            <ul>
                <li>User-generated content (e.g., recipes you create or modify).</li>
                <li>Usage data to improve app functionality and user experience.</li>
                <li>Information required for profile conversion, should you choose to personalize your profile.</li>
            </ul>
            <h2>Use of Data</h2>
            <p>
                The data we collect is used to:
            </p>
            <ul>
                <li>Provide, operate, and maintain our services.</li>
                <li>Improve, personalize, and expand our services.</li>
                <li>Understand and analyze how you use our services.</li>
                <li>Develop new products, services, features, and functionality.</li>
            </ul>
            <h2>Security</h2>
            <p>
                We value your trust in providing us your personal information and are striving to use commercially
                acceptable means of protecting it. However, no method of transmission over the internet or method of
                electronic storage is 100% secure and reliable, and we cannot guarantee its absolute security.
            </p>
            <h2>Children's Privacy</h2>
            <p>
                Our services do not address anyone under the age of 13. We do not knowingly collect personally
                identifiable information from children under 13. In the case we discover that a child under 13 has
                provided us with personal information, we immediately delete this from our servers.
            </p>
            <h2>Changes to This Privacy Policy</h2>
            <p>
                We may update our Privacy Policy from time to time. Thus, you are advised to review this page
                periodically for any changes. We will notify you of any changes by posting the new Privacy Policy on
                this page.
            </p>
            <h2>Contact Us</h2>
            <p>
                If you have any questions or suggestions about our Privacy Policy, do not hesitate to contact us at
                info@oeppe.com.
            </p>
            <p>
                This Privacy Policy was last updated on 13.2.2024.
            </p>
        </div>
    );
};

export default PrivacyPolicy;
